import { createTheme } from "@mui/material/styles";
import { nblColors } from "./colors";

// Central MUI theme - gives default-styled MUI components (buttons, spinners,
// checkboxes, dialogs, etc. with no explicit color override) the NBL teal
// brand color instead of MUI's default blue. Components that already set an
// explicit color inline are unaffected.
const muiTheme = createTheme({
  palette: {
    primary: {
      main: nblColors.primary,
      dark: nblColors.hover,
      light: nblColors.light,
      contrastText: "#ffffff",
    },
    secondary: {
      main: nblColors.dark,
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default muiTheme;
